import { apiClient } from './client';
import type { Car, ApiResponse } from '@/types';

export async function getFavorites(): Promise<ApiResponse<Car[]>> {
  const response = await apiClient.get<ApiResponse<Car[]>>('/favorites');
  return response.data;
}

export async function getFavoriteIds(): Promise<ApiResponse<string[]>> {
  const response = await apiClient.get<ApiResponse<string[]>>('/favorites/ids');
  return response.data;
}

export async function getFavoriteCount(): Promise<ApiResponse<{ count: number }>> {
  const response = await apiClient.get<ApiResponse<{ count: number }>>('/favorites/count');
  return response.data;
}

export async function checkFavorite(carId: string): Promise<ApiResponse<{ isFavorite: boolean }>> {
  const response = await apiClient.get<ApiResponse<{ isFavorite: boolean }>>(`/favorites/check/${carId}`);
  return response.data;
}

export async function addFavorite(carId: string): Promise<ApiResponse<unknown>> {
  const response = await apiClient.post(`/favorites/${carId}`);
  return response.data;
}

export async function removeFavorite(carId: string): Promise<ApiResponse<void>> {
  const response = await apiClient.delete<ApiResponse<void>>(`/favorites/${carId}`);
  return response.data;
}
